import { useTranslation } from "react-i18next"
import { StatusEnum } from "../data/book/data-types"

export const useStatusTranslations = () => {
    const { t } = useTranslation("common")

    const statusMap: { [key: number]: string } = Object.keys(StatusEnum).reduce((acc, el) => ({ ...acc, [el]: t(`status.${el}`)}), {})

    return (status: StatusEnum): string => statusMap[status] || ""
}